<template>
  <div class="authorization_detail_box">
    <!-- <p class="title">Anyhai-DTwin授权明细</p>
    <section class="authroization_detail_img_box"></section> -->
            <img class="responsive-img" src="../../assets/images/chayi.png" alt="描述文本" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.authorization_detail_box {
  width: 100%;
  /* padding-left: 361px;
  padding-top: 60px; */
  margin-bottom: 83px;
              margin: 0 auto; /* 水平居中 */
            overflow: hidden; /* 防止图片溢出 */
}


        /* 图片自适应核心样式 */
        .responsive-img {
            display: block; /* 去除图片默认行内间隙 */
            width: 100%; /* 宽度随容器自适应 */
            height: auto; /* 高度自动，保持宽高比 */
            object-fit: cover; /* 可选：裁剪图片填满容器（不拉伸），也可改为contain */
            max-width: 100%; /* 确保图片不超出自身原始宽度 */
        }

.authorization_detail_box .title {
  width: 1200px;
  /* height: 30px; */
  text-align: center;
  font-size: 32px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #ffffff;
  /* background: red; */
}
.authorization_detail_box .authroization_detail_img_box {
  width: 1200px;
  height: 3359px;
  background-image: url("../../assets/images/authorizationDetail.png");
  background-repeat: no-repeat;
  background-size: cover;
  margin-top: 39px;
}
</style>